import axios from "axios";
import { apiCompleted, apiInitiated, setInlineLoader, updateLoadingMessage } from "../state/reducers/common";
import { store } from "../state/store";

const instance = axios.create({});

instance.interceptors.request.use(async function(config) {
  try {
    console.log("Display Inline Loader: ", store.getState().common.inlineLoader);
    if (!store.getState().common.inlineLoader)
      store.dispatch(apiInitiated());
    // config.url = "http://localhost:8000" + config.url;
    // config.url = "https://code-crafter-api-v1-677861082546.us-central1.run.app" + config.url;
    config.url = "https://code-crafter-backend-677861082546.us-central1.run.app" + config.url;
    // config.url = "https://34.170.185.29" + config.url;
    // config.url = "https://code-crafter-api-v1-tjhv22t5ya-uc.a.run.app" + config.url;
    // config.url = "https://security-quick-test-tjhv22t5ya-uc.a.run.app" + config.url;
    // config.url = config.url.includes("codecrafterapi.com") ? config.url : "http://localhost:8000" + config.url
    // config.url = "http://127.0.0.1:8000" + config.url;
    // config.url = "https://34.121.74.61" + config.url;
    // config.url = "https://34.121.74.61" + config.url;
    // config.url = "https://codecrafterapi.com"+config.url;

    config.headers["Authorization"] = "Bearer access token";
    config.headers["Access-Control-Allow-Credentials"] = true;
    return config;
  } catch (error) {
    return config;
  }
});

instance.interceptors.response.use(
  (response) => {
    store.dispatch(updateLoadingMessage({
      message: ""
    }))
    if (!store.getState().common.inlineLoader)
      store.dispatch(apiCompleted())
    else
      store.dispatch(setInlineLoader(false))
    return response;
  },
  (error) => {
    store.dispatch(updateLoadingMessage({
      message: ""
    }))
    if(store.getState().common.inlineLoader)
      store.dispatch(setInlineLoader(false))
    else
      store.dispatch(apiCompleted())
    
    throw new Error(error.message);
  }
);

export default instance;